import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import moment from 'moment';
import config from '../../../../app/config';
import {useStylesECDS} from './ecdsStyle';
import InformationBox from '../../../../components/other/informationBox';
import {AgyleTable, createAgyleTableColumn} from '../../../../components/table/AgyleTable';

import {getPatientFlag} from '../../mainScreen/util/patientFlagsUtil';

const COLUMNS = [
    createAgyleTableColumn('no', 'No.', 1, null, 'count', 'notSort', 'medium', 'center', true, false, null, null, null),
    createAgyleTableColumn('treatmentDate', 'Treatment Date and Time', 2, 'treatmentDate', 'string', '', 'medium', 'left', true, true, null, null, null),
    createAgyleTableColumn('expectedDate', 'Expected Date and Time of Treatment', 3, 'expectedDate', 'string', '', 'medium', 'right', true, false, null, null, null),
];

const TimeOfTreatment = (props) => {
    const {t} = useTranslation();
    const classes = useStylesECDS();

    // Data
    const [dataForm, setDataForm] = useState({
        treatmentTimestamp: null,
        expectedDateTimestampTreatment: null,
    });
    const [date, setDate] = useState([]);

    // Init Data 111 Flag
    useEffect(() => {
        const flag111 = getPatientFlag(props.patient, '111');
        if (flag111?.checked) {
            setDataForm({
                treatmentTimestamp: flag111?.date,
                expectedDateTimestampTreatment: flag111?.when111,
            });
            setDate([
                {
                    treatmentDate: moment(flag111?.date).format(config.defaultDateTimeFormat),
                    expectedDate: moment(flag111?.when111).format(config.defaultDateTimeFormat),
                },
            ]);
        }
    }, []);


    const setDataDictionary = () => {
        const list = [];
        if (props.version === 'V3') {
            list.push({
                EmergencyCareTreatmentTimestamp: moment(dataForm.treatmentTimestamp).set('second', 0).format(config.ecdsDateTimeFormat),
                EmergencyCareExpectedDateTimestampTreatment: moment(dataForm.expectedDateTimestampTreatment).set('second', 0).format(config.ecdsDateTimeFormat),
            });
        } else if (props.version === 'V4') {
            list.push({
                EmergencyCareTreatmentAllocationTimestamp: moment(dataForm.treatmentTimestamp).set('second', 0).format(config.ecdsDateTimeFormat),
                EmergencyCareExpectedDateAndTimestampOfTreatment: moment(dataForm.expectedDateTimestampTreatment).set('second', 0).format(config.ecdsDateTimeFormat),
            });
        }
        props.setData(list);
    };

    const validation = () => {
        return dataForm.treatmentTimestamp && dataForm.expectedDateTimestampTreatment;
    };

    useEffect(() => {
        if (validation()) setDataDictionary();
    }, [dataForm]);

    const renderTable = () => {
        const check = !!dataForm.expectedDateTimestampTreatment || !!dataForm.treatmentTimestamp;

        if (check) {
            return (
                <>
                    <AgyleTable
                        columns={COLUMNS}
                        data={date}
                    />
                </>
            );
        } else {
            return (
                <>
                    <InformationBox type="info">
                        {t('Flag 111 not activated.')}
                    </InformationBox>
                </>
            );
        }
    };

    return (
        props.accordion === 'Expected Time of Treatment' &&
        <div className={classes.root} style={{paddingTop: 1}}>
            {renderTable()}
        </div>
    );
};

export default TimeOfTreatment;
